<template>
    <div v-if="!!record&&!!record.request_type">
        <div v-if="record.request_type==='Government Forms'" class="uk-grid uk-grid-small">
            <div class="uk-width-1-5 lam-label-column">
                <div class="uk-form-controls-text uk-text-right">Forms</div>
            </div>
            <div class="uk-width-4-5">
                <div class="uk-grid uk-grid-small uk-grid-width-1-2">
                    <form-checkbox
                        v-for="government_form in government_forms"
                        :key="government_form.id"
                        :id="`government-form-${government_form.id}`"
                        :value="record.government_form_ids.indexOf(government_form.id)>=0"
                        :name="`${government_form.id}`"
                        :editable="true"
                        @input="toggle_government_form"
                    >
                        <span class="uk-text-nowrap">{{ government_form.name }}</span>
                    </form-checkbox>
                </div>
            </div>
        </div>
        <div v-if="has_notes" class="uk-grid uk-grid-small">
            <div class="uk-width-1-1">
                <form-text-area
                    id="material-request_notes"
                    name="notes"
                    v-model="record.notes"
                    width="1-1"
                    size="large"
                    :editable="is_editable"
                    :required="false"
                    placeholder="Description"
                    @input="save_field"
                />
            </div>
        </div>
    </div>
</template>

<script>
import request_for_material_body from "./request_for_material_body"
import string_utilities from "../../../mixins/StringUtilities"

import FormCheckbox from "../../../ui/FormCheckbox"
import FormTextArea from "../../../ui/FormTextArea"

export default {
    mixins: [request_for_material_body, string_utilities],
    components: {
        FormCheckbox,
        FormTextArea
    },
    methods: {
        toggle_government_form (checked, type) {
            type = parseInt(type) || 0
            if(!type) return
            const government_form_ids = this.record.government_form_ids.slice()
            const index = government_form_ids.indexOf(type)
            if(checked && (index < 0)) government_form_ids.push(type)
            else if(!checked && (index >= 0)) government_form_ids.splice(index, 1)
            this.save_field(government_form_ids, "government_form_ids")
        }
    },
    computed: {
        is_editable () {
            return !!this.editable && !this.sent_at
        },
        government_forms () {
            return this.dictionary("government_forms", "name")
        },
        has_notes () {
            if(this.record.request_type !== "Government Forms") return true
            if(!this.government_forms || !this.government_forms.length || !this.record.government_form_ids || !this.record.government_form_ids.length) return false

            const other = this.government_forms.find((government_form) => {
                return !!government_form.name.match(/^other$/i)
            })
            if(!other) return false

            return this.record.government_form_ids.indexOf(other.id) >= 0
        }
    }
}
</script>
